<template>
  <sc-card
    :title="$t('weather')"
    :footer="footer"
    :secondFooter="secondFooter && isShowForecast"
    v-loading="isLoading"
  >
    <main-info
      v-if="weatherForecast.length && currentWeather"
      :currentWeather="currentWeather"
    />
    <additional-info
      slot="footer"
      :currentWeather="currentWeather"
      v-if="footer && currentWeather"
    />
    <forecast
      slot="second-footer"
      :weatherForecast="weatherForecast"
      v-if="secondFooter && currentWeather && isShowForecast"
    />
  </sc-card>
</template>

<script>
import scCard from "../../layout/card";
import {
  getDatetime,
  getWeatherUrls,
  getWeatherIconName
} from "../../../configs";
import mainInfo from "./components/main";
import additionalInfo from "./components/additional";
import forecast from "./components/forecast";

export default {
  components: { scCard, mainInfo, additionalInfo, forecast },
  data() {
    return {
      city: this.$store.state.situationCenter.config.city,
      timeZone: this.$store.state.situationCenter.config.timeZone,
      clientHeight: document.documentElement.clientHeight,
      footer: true,
      secondFooter: true,
      isLoading: false,
      refreshData: null,
      currentWeather: null,
      currentHour: null,
      currentDate: null,
      weatherForecast: [],

      getWeatherIconName
    };
  },
  computed: {
    isShowForecast() {
      return this.clientHeight < 1030 ? false : true;
    }
  },
  methods: {
    async getWeather() {
      if (!getWeatherUrls(this.city)) return;
      const dateTime = getDatetime(this.timeZone);
      this.currentHour = Number(dateTime.getHours());
      this.currentDate = Number(dateTime.getDate());
      const weatherForecast = [];
      let currentWeather;

      try {
        const response = await fetch(getWeatherUrls(this.city)[0]);
        const json = await response.json();
        const currentWeatherResponse = await fetch(
          getWeatherUrls(this.city)[1]
        );
        currentWeather = await currentWeatherResponse.json();

        for (let i = 0; i < 5; i++) {
          weatherForecast.push(json.list[i]);
        }
        this.isLoading = false;
      } catch (e) {
        console.log(e);
        this.isLoading = false;
      }

      weatherForecast[0].main = currentWeather.main;
      weatherForecast[0].weather = currentWeather.weather;
      this.weatherForecast = weatherForecast;
      this.setCurrentWeather(currentWeather);
    },
    getTemp(value) {
      const temp = Math.trunc(value);

      return temp > 0 ? `+${temp}` : temp;
    },
    getDate(value) {
      return Number(
        value
          .split(" ")[0]
          .split("-")
          .pop()
      );
    },
    getHour(value) {
      return Number(
        value
          .split(" ")
          .pop()
          .split(":")[0]
      );
    },
    setCurrentWeather(value) {
      let temp, id, name, humidity, wind, visibility;

      if (value) {
        temp =
          value.main.temp || value.main.temp === 0
            ? this.getTemp(value.main.temp)
            : 0;
        id = value.weather[0].id ? value.weather[0].id : null;
        name = value.weather[0].main ? value.weather[0].main : null;
        humidity = value.main.humidity ? value.main.humidity : null;
        wind = value.wind && value.wind.speed ? value.wind.speed : null;
        visibility = value.visibility ? value.visibility / 1000 : null;
      }

      const currentWeather = {
        icon: getWeatherIconName(id, this.currentHour),
        temp,
        id,
        name,
        humidity,
        wind,
        visibility
      };

      this.currentWeather = currentWeather;
    }
  },
  created() {
    this.isLoading = true;
    this.getWeather();
    this.refreshData = setInterval(this.getWeather, 300000);
    this.clientHeight = document.documentElement.clientHeight;
    window.addEventListener(
      "resize",
      () => {
        this.clientHeight = document.documentElement.clientHeight;
      },
      false
    );
  },
  beforeDestroy() {
    clearInterval(this.refreshData);
  }
};
</script>

<i18n>
{
  "ru": {
    "weather": "Погода"
  },
  "en": {
    "weather": "Weather"
  }
}
</i18n>
